// @file Entrypoint for referrals welcome page
import window from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import ReferralsWelcomeApp from '@@/vuecomponents/ReferralsWelcomeApp.vue'
import { configure as configureArvo } from '@padlet/arvo'

const { arvoConfig, ...otherProps } = window.ww.vueStartingState
void configureArvo(arvoConfig)

void setupVueApp({
  el: '#referrals_welcome_app',
  rootComponent: ReferralsWelcomeApp,
  usePinia: true,
  rootComponentProps: () => otherProps,
})
